export default __webpack_public_path__ + "static/media/hero-payroll.57584282.jpg";